import React from "react"

import LocaleLink from "../LocaleLink"
import RichText from "../RichText"
import Excerpt from "../Excerpt"

import { PageModel } from "../../models/pages"
import { GatsbyImage } from "gatsby-plugin-image"

import { getPlainText, getPrettyURL } from "../../utils"
import { CmsImage } from "../../models/common"

interface Props extends PageModel {
  cssClass?: string
  listingImage?: CmsImage
  imageFocus?: string
}

const defaultProps = {}

export const PageCard: React.FC<Props> = props => {
  // console.log("PageCard: ", props)
  const listingImage = props.listing?.listing_img || props.hero.listing_img
  const heroFocus = props.hero.image_focus?.toLowerCase() || "center"
  const imageFocus = props.listing?.listing_img ? "center" : heroFocus

  return (
    <div
      className={`card colorCard ${props.listing?.listing_color || "color--1"}`}
    >
      <div className="grid-y card__inner">
        <LocaleLink
          to={getPrettyURL(props)}
          className="cell auto card__link"
          pageContext={props.pageContext}
        >
          {listingImage && (
            <GatsbyImage
              image={listingImage?.gatsbyImageData}
              alt={getPlainText(props.hero.heading) || ""}
              className={`card__image ${
                props.listing?.darken_image ? "darken" : ""
              }`}
              objectFit="cover"
              objectPosition={imageFocus}
            />
          )}
          <div className="grid-y card__content">
            <RichText
              content={props.hero.heading}
              cssClass="cell auto card__heading"
              pageContext={props.pageContext}
            />
            <div className="cell shrink card__excerpt">
              <Excerpt clamp={3}>
                <RichText
                  content={props.listing?.excerpt}
                  pageContext={props.pageContext}
                />
              </Excerpt>
            </div>
          </div>
        </LocaleLink>
        <div className="cell shrink card__tags">
          <div className="tagList" />
        </div>
      </div>
    </div>
  )
}

PageCard.defaultProps = defaultProps

export default PageCard
